module.exports = __webpack_public_path__ + "static/media/team_sm.5b2a57ac.png";